export default __webpack_public_path__ + "static/media/santander.bec5d541.png";